import React from 'react';
import Grid from './Grid.jsx';

class Movimentacoes extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [ "Centro" ],
            centros: []
        };

    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes === "nenhuma") {
            window.location.href = "/home";
        }

        fetch("/api/centro/grid2", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centros: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="movimentacoes-title">Movimentações Financeiras</h1><br />
                <p id="movimentacoes-txt">
                    Escolha um centro para verificar as suas movimentações financeiras.
                </p><br />
                <Grid key={ this.state.centros }
                    header={ this.state.gridHeader }
                    data={ this.state.centros }
                    pageSize={ 10 }
                    gridWidth={ "600px" }
                    linkTo={ "/movimentacoescentro" } />
            </div>
        );
    }

}

export default Movimentacoes;

